import { createContext, useContext, useState, useCallback, ReactNode } from "react";

interface SignupModalContextType {
  isOpen: boolean;
  sourcePage: string;
  openSignupModal: (source: string) => void;
  closeSignupModal: () => void;
}

const SignupModalContext = createContext<SignupModalContextType | undefined>(undefined);

export const SignupModalProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [sourcePage, setSourcePage] = useState("");

  const openSignupModal = useCallback((source: string) => {
    setSourcePage(source);
    setIsOpen(true);
  }, []);

  const closeSignupModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <SignupModalContext.Provider value={{ isOpen, sourcePage, openSignupModal, closeSignupModal }}>
      {children}
    </SignupModalContext.Provider>
  );
};

export const useSignupModal = () => {
  const ctx = useContext(SignupModalContext);
  if (!ctx) throw new Error("useSignupModal must be used within SignupModalProvider");
  return ctx;
};
